import React from 'react';

export default function ShowLessonNavIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 15.2222L17 2.77778C17 1.79594 16.2041 1 15.2222 1L2.77778 0.999999C1.79594 0.999999 1 1.79594 1 2.77778L0.999999 15.2222C0.999999 16.2041 1.79594 17 2.77778 17L15.2222 17C16.2041 17 17 16.2041 17 15.2222Z"
        stroke="#696970"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 6.33333L1 6.33333"
        stroke="#696970"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9L9 14.3333"
        stroke="#696970"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 11.6667L9.00033 14.3333L6.33366 11.6667"
        stroke="#696970"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
